module.exports = __webpack_public_path__ + "static/f6a70ecb06f62a79e461e7ae68e7c5dc064aad882a41384f827afe8341e506e5-e66c97c06b7dd90d97dab2548c231d61.png";